import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { editStatus } from "../../redux/state/status";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

interface ActionStatusModalProps {
  uploadReceiptType: string;
  uploadStatus: boolean;
}

const ActionStatusModal = ({ uploadReceiptType, uploadStatus }: ActionStatusModalProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [failureMessage, setFailureMessage] = useState<string | null>(null);
  const [modalTitle, setModalTitle] = useState<string | null>(null);

  const botButtonColor = useSelector(
    (state: { settings: { botButtonColor: string } }) =>
      state.settings.botButtonColor
  );
  const botFontSize = useSelector(
    (state: { settings: { botFontSize: number } }) =>
      state.settings.botFontSize
  );

  const fontSizesRef = ["xs", "sm", "base", "lg", "xl"];
  const smallFontSizeRef = ["2xs", "xs", "sm", "base", "lg"];
  const fontSizes = [
    fontSizesRef[0 + botFontSize],
    fontSizesRef[1 + botFontSize],
    fontSizesRef[2 + botFontSize],
  ];
  const smallFontSizes = [
    smallFontSizeRef[0 + botFontSize],
    smallFontSizeRef[1 + botFontSize],
    smallFontSizeRef[2 + botFontSize],
  ];

  useEffect(() => {
    let title = "";
    let failureMsg: string | null = null;

    if (uploadStatus) {
      if (uploadReceiptType === "default") {
        title = t("fileUploadSuccess");
      } else if (uploadReceiptType === "deposit" || uploadReceiptType === "withdrawal") {
        title = t("uploadFileModal.successTitle");
      }
    } else {
      if (uploadReceiptType === "default") {
        title = t("fileUploadFailure");
      } else if (uploadReceiptType === "deposit" || uploadReceiptType === "withdrawal") {
        title = t("uploadFileModal.failureTitle");
      }
      failureMsg = t("uploadFileModal.defaultFailureMessage");
    }

    setModalTitle(title);
    setFailureMessage(failureMsg);
  }, [uploadStatus, uploadReceiptType, t]);

  const closeActionStatusModal = () => {
    dispatch(
      editStatus({
        name: "isActionStatusModal",
        value: false,
      })
    );
  };

  return (
    <div
      style={{ fontFamily: "'Times New Roman', Times, serif" }}
      className={classNames(
        "fixed inset-0 flex justify-center items-center bg-black/80"
      )}
    >
      <div
        className={`w-90pc xs:w-64 small:w-96 medium:w-128 bg-white shadow-lg rounded-xl overflow-hidden text-${fontSizes[0]} small:text-${fontSizes[0]} medium:text-${fontSizes[1]} large:text-${fontSizes[2]}`}
      >
        <div className="mt-6 content text-center text-sm small:text-base medium:text-lg">
          <h3 className="text-black">{modalTitle}</h3>
        </div>
        {!uploadStatus && failureMessage && (
          <div className="mt-4 content text-center text-sm small:text-base medium:text-lg">
            <h3 className="text-gray-600">{failureMessage}</h3>
          </div>
        )}
        <div>
          <button
            style={{
              backgroundColor: botButtonColor
                ? botButtonColor.slice(0, 7)
                : "#0ea5e9",
            }}
            onClick={closeActionStatusModal}
            type="button"
            className="flex justify-center items-center w-80pc px-4 py-2 rounded-lg mx-auto mb-6 mt-4 text-white font-bold shadow-lg"
          >
            {t("Okay")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionStatusModal;
